import { render, staticRenderFns } from "./QuotationViewPage.vue?vue&type=template&id=806516de&scoped=true"
import script from "./QuotationViewPage.vue?vue&type=script&lang=js"
export * from "./QuotationViewPage.vue?vue&type=script&lang=js"
import style0 from "./QuotationViewPage.vue?vue&type=style&index=0&id=806516de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "806516de",
  null
  
)

export default component.exports